import React, {useEffect, useState} from "react";
import { Box, Typography, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Grid } from "@material-ui/core";
import {getSchoolRubricScoreService, getSchools} from "../../../../services/school.service";
import LoaderWithBackDrop from "../../../../components/LoaderWithBackDrop/LoaderWithBackDrop.comp";
import {useAuth} from "../../../../context/auth";
import {useGlobalState} from "../../../../context/global_state";

function transformRubricData(rubric_school, assess_indicators) {
    // First, build a mapping of indicator_code -> indicator
    const indicatorMap = Object.fromEntries(
        assess_indicators.map(ind => [ind.indicator_code, ind])
    );

    // For each rubric_school item, map to the rubricData format
    return rubric_school.map(item => {
        const indicator = indicatorMap[item.assess_code];
        if (!indicator) return null;

        return {
            category: indicator.name, // Or customize as needed
            description: indicator.description, // or use indicator.description or custom JSX
            veryActive: indicator.assess6_rubrics1_name,
            active: indicator.assess6_rubrics2_name,
            inactive: indicator.assess6_rubrics3_name,
            veryInactive: indicator.assess6_rubrics4_name,
        };
    }).filter(Boolean); // Remove any nulls where indicator wasn't found
}

function ScoringRubricTab({ }) {
    const { authUser } = useAuth();
    const { org_code } = authUser;
    const { settings } = useGlobalState();
    const module_code = settings.selected_report;
    const [school, setSchool] = useState('');
    const [loading, setLoading] = useState(false);
    const [rubricData, setRubricData] = useState([]);

    useEffect(() => {
        const loadSchoolList = async (page = 0, rowsPerPage = 10, order = "asc", orderBy = undefined) => {
            try {
                const result = await getSchools(authUser.org_code, module_code, page, rowsPerPage, order, orderBy);
                if (result.data) {
                    console.log('Result School List --> ', result.data);
                    setSchool(result.data.data[0]?.school_name);
                }
            } catch (e) {
                console.log("Some error occurred while fetching progress data");
            }
        };
        loadSchoolList();
    }, []);

    useEffect(() => {
        async function loadPageData() {
            if (!org_code || !module_code || !school) {
                setLoading(false);
                return;
            }
            setLoading(true);
            try {
                const result_school = await getSchoolRubricScoreService(
                    org_code,
                    module_code,
                    school,
                );
                console.log('result_school', result_school);
                const { rubric_school, assess_indicators } = result_school.data;
                if (rubric_school && rubric_school.length > 0) {
                    console.log('rubric_school', rubric_school);
                    console.log('assess_indicators', assess_indicators);
                    setRubricData(transformRubricData(rubric_school, assess_indicators));
                }

            } catch (e) {
                console.log("Some error occurred while fetching Rubric Score", e);
            } finally {
                setLoading(false);
            }
        }

        loadPageData();
    }, [org_code, module_code, school]);


    return (
        <Box width="100%" display="flex" justifyContent="center" py={2}>
            <Paper
                elevation={0}
                style={{
                    width: "100%",
                    maxWidth: 1370,
                    background: "#fff",
                    borderRadius: 14,
                    padding: "32px 24px 24px 24px",
                }}
            >
                   <Grid container spacing={2} alignItems="center" justifyContent="center">
                            {/* Left Side: Text */}
                            <Grid item xs={12} md={12}>
                                <Typography style={{  fontSize: 15, color: "#111", marginBottom: 18 }}>
                                    The <span style={{ fontWeight: 800 }}> Digital Engagement and Adoption Index</span> measures how actively and intensively individuals engage with and adopt digital technology. It provides detailed insights into their levels of screen time, device utilization, digital access, media consumption patterns, and usage of AI tools, offering a comprehensive understanding of their digital behavior and technology adoption.
                                </Typography>
                                <Typography style={{
                                    fontSize: 15,
                                    color: "#111",
                                    marginBottom: 15,
                                }}>
                                    The index comprises six assessment categories, and the overall score is calculated as a composite of these categories.
                                </Typography>
                            </Grid>

                            {/* Right Side: Table */}
                            <Grid item xs={12} md={12}>
                                <TableContainer component={Paper} elevation={0} style={{
                                    boxShadow: "none",
                                    background: "transparent",
                                }}>
                                    <Table style={{ minWidth: 700, borderCollapse: "collapse" }}>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell
                                                    style={{
                                                        background: "#222",
                                                        color: "#fff",
                                                        fontWeight: 700,
                                                        fontSize: 14,
                                                        border: "1px solid #d3d3d3",
                                                        width: 150,
                                                        textAlign: "center"
                                                    }}
                                                    align="center"
                                                >
                                                    Assessment Category
                                                </TableCell>
                                                <TableCell
                                                    style={{
                                                        background: "#222",
                                                        color: "#fff",
                                                        fontWeight: 700,
                                                        fontSize: 14,
                                                        border: "1px solid #d3d3d3",
                                                        width: 260,
                                                        textAlign: "center"
                                                    }}
                                                    align="center"
                                                >
                                                    Description
                                                </TableCell>
                                                {/*<TableCell align="center" style={{*/}
                                                {/*    background: "#34cc86",*/}
                                                {/*    color: "#fff",*/}
                                                {/*    fontWeight: 700,*/}
                                                {/*    fontSize: 14,*/}
                                                {/*    border: "1px solid #d3d3d3",*/}
                                                {/*    width: 120,*/}
                                                {/*    textAlign: "center"*/}
                                                {/*}}>*/}
                                                {/*    Very Active*/}
                                                {/*</TableCell>*/}
                                                {/*<TableCell align="center" style={{*/}
                                                {/*    background: "#1ab5d7",*/}
                                                {/*    color: "#fff",*/}
                                                {/*    fontWeight: 700,*/}
                                                {/*    fontSize: 14,*/}
                                                {/*    border: "1px solid #d3d3d3",*/}
                                                {/*    width: 100,*/}
                                                {/*    textAlign: "center"*/}
                                                {/*}}>*/}
                                                {/*    Active*/}
                                                {/*</TableCell>*/}
                                                {/*<TableCell align="center" style={{*/}
                                                {/*    background: "#ffb300",*/}
                                                {/*    color: "#fff",*/}
                                                {/*    fontWeight: 700,*/}
                                                {/*    fontSize: 14,*/}
                                                {/*    border: "1px solid #d3d3d3",*/}
                                                {/*    width: 100,*/}
                                                {/*    textAlign: "center"*/}
                                                {/*}}>*/}
                                                {/*    Inactive*/}
                                                {/*</TableCell>*/}
                                                {/*<TableCell align="center" style={{*/}
                                                {/*    background: "#e53935",*/}
                                                {/*    color: "#fff",*/}
                                                {/*    fontWeight: 700,*/}
                                                {/*    fontSize: 14,*/}
                                                {/*    border: "1px solid #d3d3d3",*/}
                                                {/*    width: 120,*/}
                                                {/*    textAlign: "center"*/}
                                                {/*}}>*/}
                                                {/*    Very Inactive*/}
                                                {/*</TableCell>*/}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {rubricData.map((row, idx) => (
                                                <TableRow key={idx}>
                                                    <TableCell align="left" style={{
                                                        fontWeight: 600,
                                                        fontSize: 14,
                                                        background: "#fff",
                                                        border: "1px solid #d3d3d3",
                                                        verticalAlign: "center",
                                                        textAlign:'center',
                                                        width: 150
                                                    }}>
                                                        {row.category}
                                                    </TableCell>
                                                    <TableCell align="left" style={{
                                                        background: "#fff",
                                                        fontSize: 14,
                                                        border: "1px solid #d3d3d3",
                                                        verticalAlign: "top",
                                                        width: 260
                                                    }}>
                                                        {row.description}
                                                    </TableCell>
                                                    {/*<TableCell align="center" style={{*/}
                                                    {/*    background: "#fff",*/}
                                                    {/*    border: "1px solid #d3d3d3",*/}
                                                    {/*    fontSize: 14,*/}
                                                    {/*    textAlign:'left',*/}
                                                    {/*    width: 120*/}
                                                    {/*}}>*/}
                                                    {/*    {row.veryActive}*/}
                                                    {/*</TableCell>*/}
                                                    {/*<TableCell align="center" style={{*/}
                                                    {/*    background: "#fff",*/}
                                                    {/*    border: "1px solid #d3d3d3",*/}
                                                    {/*    fontSize: 14,*/}
                                                    {/*    textAlign:'left',*/}
                                                    {/*    width: 100*/}
                                                    {/*}}>*/}
                                                    {/*    {row.active}*/}
                                                    {/*</TableCell>*/}
                                                    {/*<TableCell align="center" style={{*/}
                                                    {/*    background: "#fff",*/}
                                                    {/*    border: "1px solid #d3d3d3",*/}
                                                    {/*    fontSize: 14,*/}
                                                    {/*    textAlign:'left',*/}
                                                    {/*    width: 100*/}
                                                    {/*}}>*/}
                                                    {/*    {row.inactive}*/}
                                                    {/*</TableCell>*/}
                                                    {/*<TableCell align="center" style={{*/}
                                                    {/*    background: "#fff",*/}
                                                    {/*    border: "1px solid #d3d3d3",*/}
                                                    {/*    fontSize: 14,*/}
                                                    {/*    textAlign:'left',*/}
                                                    {/*    width: 120*/}
                                                    {/*}}>*/}
                                                    {/*    {row.veryInactive}*/}
                                                    {/*</TableCell>*/}
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grid>
                        </Grid>
            </Paper>
            <LoaderWithBackDrop loading={loading} />
        </Box>
    );
}

export default ScoringRubricTab;